






















import { Component, Vue } from "vue-property-decorator";
@Component
export default class batchAccounter extends Vue {
    startImport: boolean = false;

    gap: number = 0;
    percent: number = 0;
    time: number = 0;
    ext: number = 0;
    form: any = {
        current: 1,
        count: 100
    };
    beforeCur: number = 0;
    perColor: string = "#8e71c7";

    keepTwoDecimal(num: any) {
        var result = parseFloat(num);
        if (isNaN(result)) {
            return 0;
        }
        result = Math.round(num * 100) / 100;
        return result;
    }

    saveAccounter() {
        let start = new Date().getTime();
        Vue.axios
            .post("accounts/saveorupdate",
                {
                    id: null,
                    name: `会计${this.form.current}`,
                    loginId: `会计${this.form.current}`,
                    selfPhone: "",
                    phone: "",
                    no: null,
                    pno: "01",
                    area: "全国",
                    role: "会计",
                    joinTime: this.$utils.simpleDateFormat(
                        new Date(),
                        "d",
                        true
                    ),
                    partyId: "",
                    partyName: ""
                }
            )
            .then((response: any) => {
                let end = new Date().getTime();
                let spend = end - start;
                this.time += Number(spend);
                let ava = this.time / (this.form.current - this.beforeCur);
                this.ext = Math.round(
                    ava * (this.form.count - this.form.current)
                );
                // let totalTime = ava * this.gap;
                this.percent += this.keepTwoDecimal(100 / this.gap);
                if (+this.form.current < +this.form.count) {
                    this.form.current++;

                    this.saveAccounter();
                } else {
                    this.percent = 100;
                    this.ext = 0;
                    setTimeout(() => {
                        this.form.count = Number(this.form.count) + this.gap;
                        this.form.current =
                            Number(this.form.count) - this.gap + 1;
                        this.startImport = false;
                    }, 1500);
                }
            })
            .catch(() => {
                this.percent = 100;
                this.ext = 0;
                this.perColor = "#f56c6c";
                setTimeout(() => {
                    this.startImport = false;
                }, 1500);
            });
    }

    start() {
        this.percent = 0;
        this.time = 0;
        this.startImport = true;
        this.beforeCur = this.form.current;
        this.gap = this.form.count - this.form.current + 1;
        this.saveAccounter();
    }
}
